import Form from "views/Form";
import className from "classnames";
import toast from "react-hot-toast";
import { parseError } from "utils/helpers";
import { useEffect, useLayoutEffect, useState } from "react";
import { searchHandler } from "models/search";
import { dropdownItemSelector } from "models/form";
import { useDispatch, useSelector } from "react-redux";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { selectAllResults } from "features/search/searchSlice";
import FormElement from "components/Form/FormElement/FormElement";
import { createSearchParams, useNavigate } from "react-router-dom";
import FormDropdown from "components/Form/FormDropdown/FormDropdown";
import { formConfig } from "pages/Configurations/UpdateConfiguration/formConfig"
import {
  useUpdateConfigurationMutation
} from "features/configuration/configurationApiSlice";

import cardStyles from "styles/modules/Card.module.scss";
import formStyles from "components/Form/Form.module.scss";
import utilityStyles from "styles/modules/Utility.module.scss";

const form = new Form(formConfig);

const UpdateConfiguration = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const searchResults = useSelector(selectAllResults);

  const [activeInput, setActiveInput] = useState("")

  const [formElements, setFormElements] = useState([]);
  const [formValidity, setFormValidity] = useState(false);

  const [updateConfig, { isLoading }] = useUpdateConfigurationMutation();

  useLayoutEffect(() => {
    form.createFormElements();
    setFormElements(form.formElements);
  }, []);

  useEffect(() => {
    dispatch(
      setNavbarTitle("Update Configuration")
    );
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (process.env.NODE_ENV === "production") {
        form.clear();
        form.setConfig(formConfig);
      }
    };
  }, []);

  const submitFormHandler = async (e) => {
    e.preventDefault();

    const formData = {};

    if (formValidity) {
      for (const key in form.getFormConfig()) {
        const el = form.getFormConfig()[key];

        if (key.split("_").pop() === "id") {
          formData[key] = el.elementConfig["data-id"];
        } else {
          formData[key] = el.elementConfig.value;
        }
      }

      try {
        await updateConfig([formData]).unwrap();
        toast.success("Config updated successfully");

        navigate({
          pathname: `/configurations`,
          search: createSearchParams({ page: "1" }).toString(),
        });
        // window.location.reload();
      } catch (error) {
        const errorMessage = parseError(error);
        toast.error(errorMessage);
      }
    }
  };

  const inputChangeHandler = (e) => {
    const { id, value } = e.target;
    setActiveInput(id);

    const updatedInput = form.inputChangeHandler(e);

    if (updatedInput) {
      if (e.target.id === "id") {
        searchHandler(
          "/configurations",
          e.target.value,
          dispatch,
          {},
          (response) => {
            return Object.entries(response).flatMap(([group, configs]) =>
              configs.map((config) => ({
                // id: config.id,
                // name: config.name,
                // label: `${config.name} (${config.id})`,
                ...config,
              }))
            );
          }
        );
      }

      form.updateFormElement({ id, config: updatedInput });

      form.checkFormValidity();

      setFormElements(form.formElements);
      setFormValidity(form.isValid);
    }
  }

  const dropdownItemClickHandler = (key, item) => {
    dropdownItemSelector(key, item, form);
    setFormElements(form.formElements);
    setActiveInput("");
  };

  return (
    <div
      className={`${utilityStyles.flexColumn} ${utilityStyles.itemsCenter} ${utilityStyles.justifyCenter}`}
    >
      <div
        className={className({
          [cardStyles.menu]: true,
          [utilityStyles.wFull]: true,
        })}
      >
        <h3>Update Configuration</h3>
      </div>
      <div className={formStyles.wrapper}>
        <form className={formStyles.container} onSubmit={submitFormHandler}>
          {formElements.map((el, idx) => {
            const { title, elementType, elementConfig, ...config } = el.config;

            return (
              <div
                key={`el-group-${idx + 1}`}
                className={className({
                  [formStyles.group]: true,
                  [utilityStyles.column100]: elementType === "textarea",
                })}
              >
                <FormElement
                  {...config}
                  title={title}
                  type={elementType}
                  id={elementConfig.id}
                  config={{
                    ...elementConfig,
                    onChange: inputChangeHandler,
                  }}
                />
                <FormDropdown
                  items={searchResults}
                  itemClickHandler={(item) =>
                    dropdownItemClickHandler(elementConfig.id, item)
                  }
                  visible={
                    activeInput === elementConfig.id && el.config.dropdown
                  }
                />
              </div>
            );
          })}
          <div className={formStyles.btn}>
            <button disabled={!formValidity || isLoading}>
              {isLoading ? "Updating config..." : "Update Config"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default UpdateConfiguration